// Copyright (c) 2017 Deere & Company

import AuditClaims from '../state/audit-claims';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateClaims = (state, action) =>
    AuditClaims.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().claimsFiltered, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED]: updateClaims
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/reducers/claims-filtered.js